
import { Link } from '@mui/material';

import { ROUTES } from '../../store/constants';
import { AuthCard } from '../cards';
import { LoginForm } from '../forms';

const LoginPanel = () => {
    return (
        <AuthCard
            title="Login"
            form={<LoginForm />}
            footer={
                <Link href={ROUTES.PASSWORD_RECOVERY} variant="body2">
                    Esqueceu a senha?
                </Link>
            }
        />
    );
};

export default LoginPanel;